import { Modal } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface PasswordChangeRequiredModalProps {
  isOpen: boolean;
}

export const PasswordChangeRequiredModal: React.FC<PasswordChangeRequiredModalProps> = ({
  isOpen,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleChangePassword = () => {
    navigate("/change-password");
  };

  return (
    <Modal
      isOpen={isOpen}
      // The modal cannot be dismissed without acting: overlay/escape are
      // disabled and the close affordance routes to the required action.
      onClose={handleChangePassword}
      closeOnOverlayClick={false}
      title={t("auth.passwordChangeRequired.title")}
      variant="warning"
      size="md"
      primaryAction={t("auth.passwordChangeRequired.action")}
      onPrimaryAction={handleChangePassword}
    >
      <p className="text-gray-600">
        {t("auth.passwordChangeRequired.description")}
      </p>
    </Modal>
  );
};
